import { jsxs as c, jsx as o, Fragment as f } from "react/jsx-runtime";
import a from "classnames";
import { useTranslation as k } from "react-i18next";
import "../../../../components/Breadcrumbs/index.js";
import l from "../../../../components/Button/index.js";
import v from "../../../../components/ButtonsContainer/index.js";
import "react";
import "reactjs-popup";
import I from "../../../../icons/Edit.js";
import g from "../../../../icons/Trash.js";
import S from "../../../../icons/FileAdd.js";
import y from "../../../../icons/FolderAdd.js";
import z from "../../../../icons/Hamburger.js";
import "../../../../components/ThemeContext/index.js";
import "../../../../components/Modal/index.js";
import "../../../../fields/FieldContainer/index.js";
import "../../../../fields/Checkbox/index.js";
import "../../../../fields/ContentEditable/index.js";
import "../../../../fields/DateInput/index.js";
import "date-fns";
import "../../../../index-YV3Z4nmr.js";
import "react-dropzone";
import "../../../../fields/Input/index.js";
import "react-dom";
import "../../../../fields/InputTooltip/index.js";
import "../../../../fields/PhoneInput/index.js";
import "../../../../fields/SocialSelect/index.js";
import "../../../../fields/Switcher/index.js";
import "../../../../fields/Textarea/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import "../../../../components/Tooltip/index.js";
const D = "forma-ui__fill-products-table-buttons__root", F = "forma-ui__fill-products-table-buttons__button", h = "forma-ui__fill-products-table-buttons__buttonIcon", x = "forma-ui__fill-products-table-buttons__buttonDescription", i = {
  root: D,
  button: F,
  buttonIcon: h,
  buttonDescription: x
}, pt = ({
  index: e,
  className: b,
  buttonsClassName: m,
  showTextShort: u,
  showDescription: n,
  onClickAdd: s,
  onClickImport: p,
  onClickAddSection: d,
  onClickAddManual: N,
  onClickRemove: _,
  onClickAny: r
}) => {
  const { t } = k();
  return /* @__PURE__ */ c(v, { className: a(i.root, b, "fill-products-table-row-buttons"), children: [
    /* @__PURE__ */ o(
      l,
      {
        className: a(i.button, m),
        iconClassName: i.buttonIcon,
        size: "extraSmall",
        viewStyle: "primary",
        icon: /* @__PURE__ */ o(I, {}),
        onClick: () => {
          N(e), r && r();
        },
        title: t("uikit:add_manually_title"),
        children: t(u ? "uikit:manually" : s ? "uikit:add_manually" : "uikit:add")
      }
    ),
    n && /* @__PURE__ */ o("div", { className: i.buttonDescription, children: t("uikit:add_manually_title") }),
    s && /* @__PURE__ */ c(f, { children: [
      /* @__PURE__ */ o(
        l,
        {
          className: a(i.button, m),
          iconClassName: i.buttonIcon,
          size: "extraSmall",
          viewStyle: "primary",
          icon: /* @__PURE__ */ o(y, {}),
          onClick: () => {
            s(e), r && r();
          },
          title: t("uikit:add_from_catalog_title"),
          children: t(u ? "uikit:from_catalog" : "uikit:add_from_catalog")
        }
      ),
      n && /* @__PURE__ */ o("div", { className: i.buttonDescription, children: t("uikit:add_from_catalog_title") })
    ] }),
    p && /* @__PURE__ */ c(f, { children: [
      /* @__PURE__ */ o(
        l,
        {
          className: a(i.button, m),
          iconClassName: i.buttonIcon,
          size: "extraSmall",
          viewStyle: "primary",
          icon: /* @__PURE__ */ o(S, {}),
          onClick: () => {
            p(e), r && r();
          },
          title: t("uikit:add_from_file_title"),
          children: t(u ? "uikit:from_file" : "uikit:add_from_file")
        }
      ),
      n && /* @__PURE__ */ o("div", { className: i.buttonDescription, children: t("uikit:add_from_file_title") })
    ] }),
    d && /* @__PURE__ */ o(
      l,
      {
        className: a(i.button, m),
        iconClassName: i.buttonIcon,
        size: "extraSmall",
        viewStyle: "primary",
        icon: /* @__PURE__ */ o(z, {}),
        onClick: () => {
          d(e), r && r();
        },
        title: t("uikit:add_section_title"),
        children: t(u ? "uikit:section" : "uikit:add_section")
      }
    ),
    n && /* @__PURE__ */ o("div", { className: i.buttonDescription, children: t("uikit:add_section_title") }),
    _ && /* @__PURE__ */ o(
      l,
      {
        className: a(i.button, m),
        iconClassName: i.buttonIcon,
        size: "extraSmall",
        viewStyle: "text",
        icon: /* @__PURE__ */ o(g, {}),
        title: t("delete"),
        onClick: () => {
          _(), r && r();
        }
      }
    )
  ] });
};
export {
  pt as default
};
